import { socket } from "@/shared/config/socket";
import { formatUSD } from "@/shared/utils/ultils";
import { useEffect, useState } from "react";

interface Props {
  market: any;
}

const RenderChiTietHangHoa = ({ market }: Props) => {
  const [dataMarket, setDataMarket] = useState<any>(null);
  useEffect(() => {
    socket.on("get_prices", (data: any) => {
      const dt = data.find((item: any) => item?.id == market?.id);
      setDataMarket(dt);
    });
  }, [market]);

  return (
    <div className="logo-market">
      <img
        className="rounded-circle"
        style={{ height: 40 }}
        src={"https://faofood.com/assets/images/commodity/" + dataMarket?.image}
      />
      <span className="ms-2">{dataMarket?.name}</span>
      <span className="ms-2" style={{ color: "hsl(49 92% 54%)" }}>
        {formatUSD(dataMarket?.price) ?? 0}
      </span>
      <span
        className="px-2"
        style={{
          color:
            dataMarket?.twenty_four_hour_change > 0
              ? "hsl(152 69% 31%)"
              : "hsl(354 70% 54%)",
          fontSize: 13,
        }}
      >
        {dataMarket?.twenty_four_hour_change
          ? dataMarket?.twenty_four_hour_change
          : 0}
      </span>
      {dataMarket?.twenty_four_hour_change > 0 ? (
        <i
          style={{ color: "hsl(152 69% 31%)" }}
          className="fa-solid fa-arrow-trend-up"
        ></i>
      ) : (
        <i
          style={{ color: "hsl(354 70% 54%)" }}
          className="fa-solid fa-arrow-trend-down"
        ></i>
      )}
    </div>
  );
};

export default RenderChiTietHangHoa;
